<template>
    <div >
      <PrimeExpand />

        <AppHeader />

        <slot />
    </div>
</template>
